// Mirrors backend app/schemas/clients/*.py (snake_case).

/** Regimes tributários (string livre ≤40). Espelha as opções do onboarding de org
 * (OrgStepOrg). Load-bearing: define teses + template de Prestação (TI-6781). */
export const TAX_REGIME_OPTIONS = [
  "Simples Nacional",
  "Lucro Presumido",
  "Lucro Real",
  "MEI",
  "Imune/Isenta",
] as const;

export interface ClientAddress {
  street: string | null;
  number: string | null;
  complement: string | null;
  neighborhood: string | null;
  city: string | null;
  state: string | null;
  zip_code: string | null;
}

/** Cofre bancário (ADR-0011). Em claro na entrada; mascarado/plain na resposta. */
export interface BankAccount {
  bank_name: string | null;
  agency: string | null;
  account: string | null;
  holder_name: string | null;
  pix_key: string | null;
}

export interface Client {
  id: number;
  workspace_id: number;
  organization_id: number;
  document: string | null; // plain — present only with pii.read.document
  document_masked: string;
  document_type: "cpf" | "cnpj";
  legal_name: string;
  tax_regime: string | null;
  parent_client_id: number | null; // filial → matriz
  is_matriz: boolean;
  responsible_user_id: number | null;
  responsible_name: string | null;
  responsible_cpf: string | null; // plain — present only with pii.read.responsible_cpf
  responsible_cpf_masked: string | null;
  active: boolean;
  can_operate: boolean; // tem contrato workspace↔cliente ativo
  created_at: string;
  // 1:1 (só no GET de detalhe). bank vem mascarado; bank plain só com pii.read.bank.
  address?: ClientAddress | null;
  bank_masked?: BankAccount | null;
  bank?: BankAccount | null;
}

export interface ClientCreatePayload {
  organization_id: number;
  document: string;
  legal_name: string;
  tax_regime?: string | null;
  responsible_user_id?: number;
  responsible_name?: string;
  responsible_cpf?: string;
}

export interface ClientUpdatePayload {
  legal_name?: string;
  active?: boolean;
  tax_regime?: string | null;
  responsible_user_id?: number;
  responsible_name?: string;
  responsible_cpf?: string;
}

export interface ResponsibleLookup {
  found: boolean;
  user_id: number | null;
  name: string | null;
}

export interface ClientContact {
  id: number;
  client_id: number;
  name: string;
  role: string | null;
  email: string | null; // plain — present only with pii.read.contact
  email_masked: string | null;
  phone: string | null;
  phone_masked: string | null;
  accepts_marketing: boolean;
  active: boolean;
  created_at: string;
}

export interface ClientContactCreatePayload {
  name: string;
  role?: string;
  email?: string;
  phone?: string;
  accepts_marketing?: boolean;
}

export interface ClientContactUpdatePayload {
  name?: string;
  role?: string;
  email?: string;
  phone?: string;
  accepts_marketing?: boolean;
  active?: boolean;
}
